export default __webpack_public_path__ + "assets/images/th-whatsapp-icon-cbf9202b.svg";